import { FunctionComponent } from 'react'
import { AvatarWithDependentsAccessWrapperProps } from './types'
import { AvatarWithDependentsAccess } from '../AvatarWithDependentsAccess'
import { characterLimiter } from '@/utils/fnUtils'
import { capitalizeFirstLetter } from '@/utils/string'
import {
  NAME_BUTTON_BY_ACCOUNT_TYPE,
  TAG_VARIANT_ACCOUNT_TYPE,
} from '../Navbar/constants'

const AvatarWithDependentsAccessWrapper: FunctionComponent<
  AvatarWithDependentsAccessWrapperProps
> = ({
  user,
  showTagAvatar,
  showButtonAvatar,
  onAvatarCustomHeaderClick,
  toggle,
  closeAction,
}) => (
  <AvatarWithDependentsAccess
    props={{
      label: characterLimiter(user?.shortName, showTagAvatar() ? 15 : 25),
      maxLabelLength: 12,
      photo: user?.photo,
      size: 'medium',
      tagLabel: capitalizeFirstLetter(user?.holder || ''),
      tagVariant: TAG_VARIANT_ACCOUNT_TYPE[user?.holder || ''],
      nameButton: NAME_BUTTON_BY_ACCOUNT_TYPE[user?.holder || ''],
      showButton: showButtonAvatar(),
      showTag: showTagAvatar(),
      onActionClick: onAvatarCustomHeaderClick,
      closeAction: closeAction,
      toggle: toggle,
    }}
  />
)

export default AvatarWithDependentsAccessWrapper
